module.exports = __webpack_public_path__ + "static/media/work.9b76d752.svg";